import React, { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useSearchNotesQuery } from "../noteApi";
import { DataTableColumn } from "../../../../components/common/datatable/DataTableTypes";
import { useFindUserSettingsByGroupNameQuery } from "../../../../components/common/userSetting/userSettingsApi";
import {
    createClickableLink,
    SearchSelectWithIndeterminateBoolean
} from "../../../../components/common/datatable/DataTableUtils";
import { SearchInputWrapper } from "../../../../components/common/datatable/filter/SearchInputWrapper";
import { SearchSelectWithList } from "../../../../components/common/datatable/filter/SearchSelectWrapper";
import Breadcrumb from "../../../../components/common/Breadcrumbs";
import { DataTable } from "../../../../components/common/datatable/DataTable";
import { getBooleanDisplayIcon } from "../../../../helpers/utils/Utils";
import { useGetEnumsQuery } from "../../../../app/globalApi";
import { getEnumDisplayNameByConstant } from "../../../../helpers/utils/EnumUtils";
import { useLazyGetCustomerByTenantAndLevelQuery } from "../../../customer/customerApi";
import { useGetCodesListQuery } from "../../../sysAdmin/code/codeApi";
import IconButton from "../../../../components/common/form/IconButton";
import { FaPlus } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { useUtilDataQuery } from "../../../profile/profileApi";
import { skipToken } from "@reduxjs/toolkit/query";
import { useGetAllTenantsQuery } from "../../../customer/tenantApi";

const NoteRule = () => {

    const codeListApi = useGetCodesListQuery("");
    const navigate = useNavigate();
    const { data: utilData } = useUtilDataQuery("");
    const [getCustomerByTenantAndLevelApi, getCustomerByTenantAndLevelApiResponse] = useLazyGetCustomerByTenantAndLevelQuery()
    const tenantQueryApi = useGetAllTenantsQuery(
        utilData?.customerLevel === 'SYS' ? undefined : skipToken
    );
    const { data: enums } = useGetEnumsQuery("");
    const [crumbs] = useState([
        { content: "Home", url: "/home" },
        { content: "Note Logics", url: "" }]
    )

    useEffect(() => {
        document.title = 'Note Logics';
    }, []);
    const { data: userSettings } = useFindUserSettingsByGroupNameQuery("Note Logic");
    const columns: DataTableColumn[] = [
        {
            label: "Name",
            accessor: "name",
            cell: (props: any) => {
                let path = "/note-logics/" + props.row.original.id;
                return createClickableLink(path, props.value, userSettings, false, "", ["LOGIC-R"]);
            },
            filterOptions: [{
                filterComponent: <SearchInputWrapper type={"text"} placeholder={"Enter Name..."} name={"name"}
                    accessor={"name"} />,
            }]
        },

        {
            label: "Product Type", accessor: "productTypes", canSort: false,
            cell: (props: any) => {
                let content = props.row.original.productTypes?.map((cur: any) => {
                    return getEnumDisplayNameByConstant(enums?.["ProductType"], cur);
                }).join(", ");

                return <><span className="text_wrap_msa_grid" title={content}>{content}</span></>
            }

        },
        {
            label: "Code", accessor: "code.name",
            filterOptions: [{
                filterComponent: SearchSelectWithList(codeListApi?.data, "name", "id", "Select Code...", false, "code.name"),
                overrideFilterLabel: "Code",
            }]
        },
        {
            label: "Tenant", accessor: "tenant",
            filterOptions: [{
                dependentColumns: ["Customer"],
                filterComponent: SearchSelectWithList(tenantQueryApi?.data, "name", "name", "Select Tenant...", false, "tenant"),
            }]
        }, {
            label: "Customer", accessor: "customer.customerName",
            canSort: false,
            filterOptions: [{
                filterComponent: SearchSelectWithList(getCustomerByTenantAndLevelApiResponse?.data, "customerName", "id", "Select Customer...", false, "customerId"),
                overrideFilterLabel: "Customer",
                overrideFilterAccessor: "customerId",
                onDependencyUpdated: (value: any) => {
                    getCustomerByTenantAndLevelApi({ tenantName: value, level: "CUSTOMER" });
                },
            }]
        },
        {
            label: "Message", accessor: "message",
            cell: (props: any) => {
                return <>
                    <span title={props.value}>
                        {props.value?.length > 50 ? props.value?.substring(0, 50) + "..." : props.value}
                    </span>
                </>
            },
            filterOptions: [{
                filterComponent: <SearchInputWrapper type={"text"} placeholder={"Enter Message..."}
                    name={"message"} accessor={"message"} />,
            }]
        },
        {
            label: "Status", accessor: "enabled",
            cell: (props: any) => getBooleanDisplayIcon(props.row.original.enabled, "Enabled", "Disabled"),
            filterOptions: [{
                filterComponent: SearchSelectWithIndeterminateBoolean("Select Status...", "Enabled", "Enabled", "Disabled"),
                overrideFilterLabel: "Enabled",
            }]
        },
    ]
    return (

        <div className="user-container px-4 py-2">
            <div className="flex justify-between mb-2.5">
                <Breadcrumb crumbs={crumbs} />
            </div>

            <DataTable
                columns={columns}
                actions={{
                    fetchAction: useSearchNotesQuery,
                    exportAction: null
                }}
                buttonOptions={{
                    addButton:
                    {
                        button: <IconButton
                            icon={<FaPlus />}
                            hasBackground={true}
                            onClick={() => {
                                navigate("/note-logics/create")
                            }}
                            title={"Add Note Logics"}
                        />,
                        permissions: ["LOGIC-C"]
                    },

                }}
                userSettingGroup={"Note Logic"}
                defaultSortOptions={{
                    accessor: "name",
                    direction: "asc"
                }}
                basePermission={"LOGIC"}
            />

        </div>

    );
};
export default NoteRule;
